import { useEffect, useState } from 'react';
import { LocalStore } from 'constants/localstore';
import { ttPublish } from 'services/social.service';
import { useAppDispatch } from 'store/store-hooks';
import { getFileLink } from './tiktok.slice';

import { ReactComponent as TikTokIco } from 'assets/social/tiktok.svg';
import styles from './_tiktok-modal.module.scss';

export const TikTokModal = () => {
  const [success, setSuccess] = useState(false);
  const dispatch = useAppDispatch();

  const cb = async () => {
    const payload = new URLSearchParams(window.location.search);
    const token = payload.get('tiktokAccessToken');
    const finalCutId = payload.get('finalCutId');
    if (!token || !finalCutId) {
      console.error('TikTok share: No token or finalCutId');
      return;
    }
    localStorage.setItem(LocalStore.tiktokOAuth, token);
    const fileUrl = await dispatch(getFileLink(Number(finalCutId))).unwrap();
    if (fileUrl !== null) await ttPublish(fileUrl, token);
    setSuccess(true);
    setTimeout(() => {
      window.close();
    }, 3000);
  };

  useEffect(() => {
    cb();
  }, []);

  return (
    <div className={styles.TtModal}>
      <TikTokIco />
      {success ? <h3>The video file has been successfully shared on TikTok! 🎉</h3> : <h3>Pending...</h3>}
    </div>
  );
};
